import * as types from './notifications.types';

export const notificationsPageSelectors: types.INotificationsPageSelectors = {
  selectFetchedNotifications: (state) => state.page.notifications.fetchedNotifications,
  selectIsFetched: (state) => state.page.notifications.isFetched,
  selectUnseenCount: (state) => state.page.notifications.unseenCount,
};
